/**
 * This leverages Bulma Css classes
 */

/**
 *
 * @param {String} elementId
 * @returns {Element|null} DOM Element or null
 * AUG 2025: to be replaced with @local_modules/generic/dom/hide-element.js
 */
export function hideElement (elementId) {
  const element = document.getElementById(elementId)
  if (!element) return null

  element.classList.add('is-hidden')
  return element
}

/**
 *
 * @param {String} elementId
 * @returns {Element|null} DOM Element or null
 * AUG 2025: to be replaced with @local_modules/generic/dom/show-element.js
 */
export function showElement (elementId) {
  const element = document.getElementById(elementId)
  if (!element) return null

  element.classList.remove('is-hidden')
  return element
}

/**
 * AUG 2025: to be replaced with @local_modules/generic/dom/set-element-html.js
 * @param {String} elementId
 * @param {String} html
 * @returns {Element|null} Returns the DOM Element from elementId or null
 */
export function setElementHtml (elementId, html) {
  const element = document.getElementById(elementId)
  if (!element) return null

  element.innerHTML = html
  return element
}
